#@import _
#@import Booking.Collections.Attributes
#@import Booking.Collections.PossibleSegments
#@import Booking.Models.Time
#@import Booking.Models.PossibleSegment
#@import Booking.Models.Base
#@import Booking.Models.Option
#@export Booking.Models.Reservation

class Booking.Models.Reservation extends Booking.Models.Base

  statuses:
    locked: 'locked'
    requested: 'requested'
    confirmed: 'confirmed'
    expired: 'expired'
    canceled: 'user_declined'

  errors:
    0:   'timeout'
    404: 'not_found'
    409: 'conflict'
    410: 'gone'
    504: 'timeout'

  constructor: (attributes, options) ->
    options = _.extend({}, options, parse: true)
    Booking.Models.Base.call(this, attributes, options)

    @on 'error', @handleError, this
    @on 'request', @loading, this
    @on 'sync', @loaded, this

  parse: (raw) ->
    return unless raw
    {additionalAttributes, option, possibleSegments, selectedSegment} = raw

    if possibleSegments?.length
      raw.possibleSegments = new Booking.Collections.PossibleSegments(possibleSegments)
      raw.possibleSegments.getTimezone = => @getTimezone()

    if selectedSegment
      raw.selectedSegment = new Booking.Models.PossibleSegment(selectedSegment)
      raw.selectedSegment.getTimezone = => @getTimezone()

    if additionalAttributes
      raw.additionalAttributes = new Booking.Collections.Attributes(additionalAttributes)

    if option
      raw.option = new Booking.Models.Option(option, {parse: true})

    raw

  handleError: (model, response) ->
    error = @errors[response.status] || 'server'
    @setError(error)

  toJSON: (options) ->
    clonedAttributes = _.clone(this.attributes)

    possibleSegments = []
    attrPossibleSegments = clonedAttributes.possibleSegments

    attrPossibleSegments.each (possibleSegModel) ->
      possibleSegments.push segment_id: possibleSegModel.get('segment_id')

    clonedAttributes.possibleSegments = possibleSegments

    return clonedAttributes

  setError: (error) ->
    @set {error}

  getError: ->
    @get('error')

  clearError: ->
    @unset('error')

  getOption: ->
    @get('option')

  getMerchant: ->
    @get('merchant')

  getUserId: ->
    @get('userId')

  getStatus: ->
    @get('status')

  getIsDTF: ->
    @get('isDTF')

  getBookingData: ->
    @get('bookingData')

  getStartDatetime: ->
    @get('startDatetime')

  getEndDatetime: ->
    @get('endDatetime')

  getDuration: ->
    @get('duration')

  isAppointmentRequest: ->
    @getOption()?.isARSE()

  getCancellationValidUntil: ->
    @get('cancellationValidUntil')

  getCancellationValidUntilDatetimeMoment: ->
    moment(@getCancellationValidUntil()).tz(@getTimezone()) if @getCancellationValidUntil()?

  canBeRescheduled: ->
    return @getCancellationValidUntilDatetimeMoment().isAfter() if @getCancellationValidUntilDatetimeMoment()? and (@isCanceled() or @isConfirmed())
    true

  getTimezone: ->
    @getOption().getLocalBookingSettings().getTimezone()

  getLocationName: ->
    @getOption().getLocationName()

  getMerchantName: ->
     @getMerchant().name

  getAttributes: ->
    @get('additionalAttributes')

  getPartySize: ->
    # Mobile reservations page parses partySize and will fail if the value is NaN but not if it's 'undefined'.
    # Only parse to an integer if actually a number.
    partySize = @get(@getAttributes().getPartySize()?.getName())
    partySize = parseInt(partySize, 10) if _.isFinite partySize
    return partySize

  getQuestion: -> # Only support one question for now
    @get(@getAttributes().getQuestions()?[0]?.getName())

  getPhone: ->
    @get(@getAttributes().getPhone()?.getName())

  getTextNotifications: ->
    @get(@getAttributes().getTextNotifications()?.getName())

  getNextReachableHour: ->
    @get('optionsNextReachableHour').next

  isFoodAndDrink: ->
    @get('isFoodAndDrink')

  isHBW: ->
    @get('isHBW')

  isReservedAvailability: ->
    @get('reservedAvailability')

  isThirdParty: ->
    @get('thirdParty')

  isMultiWindow: ->
    @get('multiWindow')

  isLocked: ->
    @getStatus() is @statuses.locked

  isRequested: ->
    @getStatus() is @statuses.requested

  isConfirmed: ->
    @getStatus() is @statuses.confirmed

  isExpired: ->
    @getStatus() is @statuses.expired

  isCanceled: ->
    @getStatus() is @statuses.canceled

  isBooked: ->
    @isRequested() or @isConfirmed() or @isLocked()

  loaded: ->
    @set('loaded', true)

  loading: ->
    @set('loaded', false)

  isLoaded: ->
    @get('loaded') is true

  isLoading: ->
    @get('loaded') is false

  cancel: ->
    @set status: @statuses.canceled
    @save()

  getSelectedSegment: -> @get('selectedSegment')
  getPossibleSegments: -> @get('possibleSegments')
